function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Base from './base';

var safeDivide = function safeDivide(numerator, denominator) {
  if (!numerator) {
    numerator = 0;
  }

  if (!denominator) {
    denominator = 0;
  }

  if (denominator === 0) {
    return 0;
  }

  return numerator / denominator;
}; // @namespace Model


var Segment = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Segment, _Base);

  function Segment() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Segment.prototype;

  _proto.percentOfSegmentingOption = function percentOfSegmentingOption(opts) {
    if (opts == null) {
      opts = {};
    }

    var numerator = this.get('results_count');
    var denominator = this.collection.responseCount(opts);
    return safeDivide(numerator, denominator);
  };

  _proto.percentOfMaxResponseCount = function percentOfMaxResponseCount(opts) {
    if (opts == null) {
      opts = {};
    }

    var numerator = this.get('results_count');
    var denominator = this.collection.maxResponseCount(opts);
    return safeDivide(numerator, denominator);
  };

  return Segment;
}(Base);

export default Segment;